import { render, staticRenderFns } from "./cakeChart.vue?vue&type=template&id=5450e8b7&scoped=true&"
import script from "./cakeChart.vue?vue&type=script&lang=js&"
export * from "./cakeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5450e8b7",
  null
  
)

export default component.exports